/**
 * Labstep
 *
 * @module screens/User/Show/Profile
 * @desc User Profile
 */

import { LayoutLinksState } from 'labstep-web/components/Layout/Links/State';
import { LayoutLinksVerticalState } from 'labstep-web/components/Layout/Links/Vertical/State';
import UserBasic from 'labstep-web/components/User/Basic';
import { withAuthenticatedUserEntity } from 'labstep-web/containers/AuthenticatedUser';
import { Flex } from 'labstep-web/core/Flex';
import { ModalDefaultContainer as ModalDefault } from 'labstep-web/core/Modal/Default';
import type React from 'react';
import type { IUserShowProfileProps } from './types';
import { getBasicLinks, getFullLinks, getGroupLinks } from './utils';

const UserShowProfile: React.FC<IUserShowProfileProps> = ({
  user,
  authenticatedUserEntity,
  ...rest
}) => (
  <ModalDefault
    size="large"
    closeOnDimmerClick
    content={
      <Flex spacing="gap" column grow>
        <UserBasic user={user} />
        {authenticatedUserEntity.userOrganizationOrganization ? (
          <LayoutLinksVerticalState
            links={getFullLinks(
              user,
              authenticatedUserEntity.userOrganizationOrganization,
            )}
            groups={getGroupLinks(user)}
          />
        ) : (
          <LayoutLinksState tabs={getBasicLinks(user)} />
        )}
      </Flex>
    }
    {...rest}
  />
);

export default withAuthenticatedUserEntity(UserShowProfile);
